import TheGrid from '@/views/history/grid'
import Edit from '@/views/history/edit'
import TheView from '@/views/history/view'

export default {
  path: '/history',
  redirect: '/history/index',
  name: 'history',
  meta: {
    auth: {
      redirect: {
        name: 'history.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Actividades'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'history.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'history.create',
    component: Edit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'history.edit',
    component: Edit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }, {
    path: 'view/:id',
    name: 'history.view',
    component: TheView,
    meta: {
      auth: true,
      label: 'Ver'
    }
  }]
}
